import { ALL_FAMILIES, type FamilyKey } from "@/data/activation-families";

/** Reads the families saved from the last visit. Anything unreadable or unknown is ignored. */
export function parseStoredFamilies(raw: string | null): FamilyKey[] | null {
  if (!raw) return null;
  try {
    const value: unknown = JSON.parse(raw);
    if (!Array.isArray(value)) return null;
    return ALL_FAMILIES.filter((f) => value.includes(f));
  } catch {
    return null;
  }
}

const key = (userId: string) => `ernest:families:${userId}`;

export function readStoredFamilies(userId: string | undefined): FamilyKey[] | null {
  if (!userId || typeof window === "undefined") return null;
  try {
    return parseStoredFamilies(window.localStorage.getItem(key(userId)));
  } catch {
    return null;
  }
}

export function writeStoredFamilies(userId: string | undefined, families: FamilyKey[]): void {
  if (!userId || typeof window === "undefined") return;
  try {
    window.localStorage.setItem(key(userId), JSON.stringify(families));
  } catch {
    /* storage can be unavailable (private window, blocked site data) */
  }
}
